import React, { useState, useRef, useEffect, useId } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SPRING } from "@/CONSTANTS";

export const CollapseTransitionItem = ({ children, id }) => {
  const autoId = useId();
  const key = id || autoId;

  const [animating, setAnimating] = useState(false);
  const ref = useRef(null);
  const [parentGap, setParentGap] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el?.parentElement) return;
    const gap = parseFloat(getComputedStyle(el.parentElement).gap) || 0;
    setParentGap(gap);
  }, []);

  const negateMargin = parentGap ? -parentGap : 0;

  return (
    <motion.div
      ref={ref}
      key={key}
      initial={{ height: 0, opacity: 0, marginTop: negateMargin }}
      animate={{ height: "auto", opacity: 1, marginTop: 0 }}
      exit={{ height: 0, opacity: 0, marginTop: negateMargin }}
      transition={SPRING}
      onAnimationStart={() => setAnimating(true)}
      onAnimationComplete={() => setAnimating(false)}
      style={{ overflow: animating ? "hidden" : "visible" }}
    >
      {children}
    </motion.div>
  );
};

export const CollapseTransition = ({ children, isVisible = true, id }) => (
  <AnimatePresence initial={false}>
    {isVisible && (
      <CollapseTransitionItem id={id}>
        {children}
      </CollapseTransitionItem>
    )}
  </AnimatePresence>
);
